export const STATUS_LEVELS = {
  GREEN: 'GREEN',
  GOLD: 'GOLD',
  RESERVE: 'RESERVE',
};

export const STATUS_NEXT_LEVELS = {
  GREEN: STATUS_LEVELS.GOLD,
  GOLD: STATUS_LEVELS.RESERVE,
  RESERVE: STATUS_LEVELS.RESERVE,
};
